/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react';

export const useSessionStorage = <T>(keyName: string, defaultValue: T) => {
  if (typeof window === 'undefined') {
    return { storedValue: defaultValue, setValue: () => null, removeValue: () => null };
  }
  const [storedValue, setStoredValue] = useState<T>(() => {
    const value = sessionStorage.getItem(keyName);

    if (value) {
      return JSON.parse(value);
    } else {
      sessionStorage.setItem(keyName, JSON.stringify(defaultValue));
      return defaultValue;
    }
  });

  const setValue = (newValue: T) => {
    sessionStorage.setItem(keyName, JSON.stringify(newValue));
    setStoredValue(newValue);
  };

  const removeValue = () => {
    sessionStorage.removeItem(keyName);
    setStoredValue(defaultValue);
  };

  return { storedValue, setValue, removeValue };
};
